import { render, staticRenderFns } from "./TeacherHeaderPage.vue?vue&type=template&id=7aa62502"
import script from "./TeacherHeaderPage.vue?vue&type=script&lang=js"
export * from "./TeacherHeaderPage.vue?vue&type=script&lang=js"
import style0 from "./TeacherHeaderPage.vue?vue&type=style&index=0&id=7aa62502&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports